<template>
  <div class="dy-button-box">
    <el-button
      :v-zoom="isZoom ? { from: zFormText, name: zNameText } : {}"
      @click.prevent="$emit('click')"
      :disabled="disabled"
      :class="['new-btn', typeClass, hasMinWidth, hasLightHight, textDisabled]"
      :style="btnWidth != '' ? { width: btnWidth } : styleObj"
      :loading="loading"
      v-preventReClick="preventReClick"
    >
      <slot>{{ label }}</slot>
    </el-button>
  </div>
</template>

<script>
export default {
  name: "dy-button",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isPrevent: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [String, Number],
      default: "",
    },
    isZoom: {
      type: Boolean,
      default: false,
    },
    // 按钮埋点参数
    zForm: {
      type: String,
      default: "",
    },
    zName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 按钮类型
     *  default    白色 悬停变灰
     *  break      黑色 悬停变灰黑
     *  blue       蓝色 悬停变浅蓝 （查询按钮）
     *  select     灰色 悬停变蓝色 （已选x个按钮）
     *  toBlue     白色 悬停变蓝
     *  gley       灰色 悬停变黑色字体 （重置按钮）
     *  text       黑色文字 悬停变深黑
     *  blueText   蓝色文字 悬停变浅蓝
     *  labelSelect 灰底 悬停变浅蓝
     *  darkBlue  深蓝色（互动管理）
     *  darkGrey  深灰色（互动管理）
     */
    type: {
      type: String,
      default: "default",
      // validator: (value) =>
      //   ["default", "break", "blue", "text", "blueText",].includes(value),
    },
    // 按钮宽度
    // tip：传width的时候传styleTextObj是无效的
    /**     
     * 使用例子：
     * <dy-button
          :styleTextObj="{'border-radius': '4px', width: '80px'}"
          >关闭</dy-button
        >
        <dy-button
          width='80px'
          >关闭</dy-button
        >
    **/
    width: {
      type: String,
      default: "",
    },
    styleTextObj: {
      type: Object,
      default: null,
    },
    // 是否设置最小宽度
    isMinWidth: {
      type: Boolean,
      default: true,
    },
    preventReClick: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    typeClass() {
      if (this.type != "") {
        if (this.type == "gley") {
          return "glay-btn";
        }
        return `${this.type}-btn`;
      } else {
        return "default-btn";
      }
    },
    zFormText() {
      return this.zForm ? this.zForm : "";
    },
    zNameText() {
      return this.zName ? this.zName : "";
    },
    hasMinWidth() {
      if (this.type != "text" && this.type != "blueText" && this.isMinWidth) {
        return "min-width";
      } else {
        return "";
      }
    },
    hasLightHight() {
      if (this.type != "text" && this.type != "blueText") {
        return "line-height-box";
      } else {
        return "";
      }
    },
    btnWidth() {
      return this.width;
    },
    styleObj() {
      return this.styleTextObj ? this.styleTextObj : {};
    },
    textDisabled() {
      if ((this.type == "text" || this.type == "blueText") && this.disabled) {
        return "text-disabled";
      } else if (this.disabled) {
        return this.type + "-disabled";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dy-button-box {
  display: inline-block;
  & + & {
    margin-left: 8px;
  }
  .new-btn {
    padding: 0 16px;
    border-radius: 4px;
    font-size: 14px;
    height: auto;
    width: auto;
  }
  .break-btn {
    color: #ffffff;
    background: #7B61FF;
    border: 1px solid #7B61FF;
    border-radius: 4px;
    font-weight: 400px;
    &:hover {
      background: #9581FF;
      border: 1px solid #9581FF;
      border-radius: 4px;
    }
    &:focus {
      background: #7B61FF;
      border: 1px solid #7B61FF;
      border-radius: 4px;
    }
    &.is-disabled {
      color: #ffffff;
      background: #bfbfbf;
      border-radius: 4px;
    }
  }
  .default-btn {
    background: #ffffff;
    border: 1px solid #dcdfe6;
    color: #666666;
    &:hover {
      border: 1px solid #f2f3f5;
      color: #666666;
      background: #f2f3f5;
    }
  }
  .blue-btn {
    background: rgba(39, 104, 255, 0.1);
    color: #7B61FF;
    border: none;
    border: 1px solid #7b61ff;
    transition: all 0.2s;
    &:hover {
      // color: #9581FF;
      background: #7b61ff;
      color: #fff;
      // background: rgba(39, 104, 255, 0.1);
    }
    &.is-disabled {
      color: #999999;
      background: #f2f3f5;
    }
  }
  .select-btn {
    background: #f2f3f5;
    color: #666666;
    border: none;
    border: 1px solid #f2f3f5;
    &:hover {
      color: #9581FF;
      background: rgba(39, 104, 255, 0.1);
    }
  }
  .gley-btn {
    background: #f2f3f5;
    color: #666666;
    border: none;
    // border: 1px solid #f2f3f5;
    &:hover {
      background: #f2f3f5;
      color: #000;
      // border: 1px solid #f2f3f5;
    }
  }
  .text-btn {
    color: #666666;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: #1f1f1f;
    }
  }
  .blueText-btn {
    color: #7B61FF;
    border: none;
    padding: 0 !important;
    background: transparent;
    width: auto;
    &:hover {
      color: #9581FF;
    }
  }
  .labelSelect-btn {
    background: #f5f5f7;
    border: none;
    &:hover {
      background: rgba(39, 104, 255, 0.1);
      color: #7B61FF;
      border: none;
    }
  }
  .toBlue-btn {
    background: #f2f3f5;
    border: none;
    &:hover {
      background: rgba(39, 104, 255, 0.1);
      color: #7B61FF;
      border: none;
    }
  }
  .darkBlue-btn {
    background: #7B61FF;
    color: #ffffff;
    border: none;
    // border: 1px solid #f2f3f5;
    &:hover {
      background: #4e83ff;
      color: #ffffff;
      // border: 1px solid #f2f3f5;
    }
  }
  .darkGrey-btn {
    background: #eaeaea;
    color: rgba(0, 0, 0, 0.6);
    border: none;
    // border: 1px solid #f2f3f5;
    &:hover {
      background: #e8e8e8;
      color: #333333;
      // border: 1px solid #f2f3f5;
    }
  }
  .min-width {
    min-width: 68px;
  }
  .line-height-box {
    line-height: 32px;
  }
  .text-disabled {
    color: #999999;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: #999999;
    }
  }
  .default-disabled {
    opacity: 0.5;
    cursor: no-drop;
    &:hover {
      background: #ffffff;
      border: 1px solid #dcdfe6;
      color: #666666;
      opacity: 0.5;
    }
  }
}
</style>
